import axios from 'axios';
import CommonConstants from '../utils/CommonConstants';
const apiUrl = CommonConstants.Actions.api;

export function getPerPoundValue(token,warehouse_id = 1){
	return function(dispatch){
	axios.get(apiUrl+'settings/per_pound_value/'+warehouse_id,token)
	.then((response) => {
	dispatch({type: 'GET_PER_POUND_VALUE_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_PER_POUND_VALUE_REJECTED', payload: err,})
	})
	}
	}
	export function getStorageSettings(warehouse_id = 1){
    const token = localStorage.jwtToken;
    return function(dispatch){
      axios.get(apiUrl+'settings/storage/'+warehouse_id,token)
      .then((response) => {
        dispatch({type: 'GET_STORAGE_SETTINGS_FULFILLED', payload: response.data,})
      }).catch((err) =>{
        dispatch({type: 'GET_STORAGE_SETTINGS_REJECTED', payload: err,})
      })
    }
	}
	export function getGeneralSettings(token,warehouse_id = 1){
	return function(dispatch){
	axios.get(apiUrl+'settings/general_setting/'+warehouse_id,token)
	.then((response) => {
	dispatch({type: 'GET_GENERAL_SETTINGS_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_GENERAL_SETTINGS_REJECTED', payload: err,})
	})
	}
	}
	export function getFees(token,warehouse_id = 1){
	return function(dispatch){
	axios.get(apiUrl+'settings/air_cargo_fees/'+warehouse_id,token)
	.then((response) => {
	dispatch({type: 'GET_FEES_FULFILLED', payload: response.data,})

	}).catch((err) =>{
	dispatch({type: 'GET_FEES_REJECTED', payload: err,})
	})
	}
	}
	export function getCurrencyConversion(token,warehouse_id = 1){
	return function(dispatch){
	axios.get(apiUrl+'settings/currency_conversion/'+warehouse_id,token)
	.then((response) => {
	dispatch({type: 'GET_CURRENCY_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_CURRENCY_REJECTED', payload: err,})
	})
	}
	}
	export function getTurnaroundDeliveryTime(token,warehouse_id = 1){
	return function(dispatch){
	axios.get(apiUrl+'settings/turnaround_delivery_time/'+warehouse_id,token)
	.then((response) => {
	dispatch({type: 'GET_TURNAROUND_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_TURNAROUND_REJECTED', payload: err,})
	})
	}
	}
	export function getCopyrightYear(){
	return function(dispatch){
	axios.get(apiUrl+'year')
	.then((response) => {
	dispatch({type: 'GET_YEAR_FULFILLED', payload: response.data,})
	}).catch((err) =>{
	dispatch({type: 'GET_YEAR_REJECTED', payload: err,})
	})
	}
}
export function getDestinationSettings(id = 1,destination_country){
  return function(dispatch){
    axios.post(apiUrl+'settings/all',
    {
      "data":{
        "warehouse_id": id,
        "destination_country": destination_country
      }
    })
    .then((response) => {
      dispatch({type: 'GET_DESTINATION_SETTINGS_FULFILLED', payload: response.data});
    }).catch((err) =>{
      dispatch({type: 'GET_DESTINATION_SETTINGS_REJECTED', payload: err})
    })
  }
}
export function getGlobalSettings(id = 6){
  return function(dispatch){
    axios.post(apiUrl+'settings/all',
    {
      "data":{
        "warehouse_id": id,
      }
    })
    .then((response) => {
      dispatch({type: 'GET_GLOBAL_SETTINGS_FULFILLED', payload: response.data});
    }).catch((err) =>{
      dispatch({type: 'GET_GLOBAL_SETTINGS_REJECTED', payload: err})
    })
  }
}


/** WEBPACK FOOTER **
 ** ./src/actions/SettingsAction.js
 **/